import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Fa from 'react-fontawesome';
import NumberDisplay from '../../../../components/number-display';

class UserRoleCountRenderer extends Component {
  constructor(props) {
    super(props);
    this.state = {};
    this.handleCountClick = this.handleCountClick.bind(this);
  }

  handleCountClick(e) {
    e.preventDefault();
    this.props.openModal(this.props.data, this.props.role, this.props.connected, this.props.license);
  }

  render() {
    const { value, data } = this.props;
    let inner = null;
    if (data && data.$loadingStats === true) {
      inner = (<Fa name="spinner" spin className="text-muted" />);
    } else {
      inner = (<NumberDisplay value={value} precision={0} />);
    }
    return (
      <a href='' onClick={this.handleCountClick}>
        {inner}
      </a>
    );
  }
}

UserRoleCountRenderer.propTypes = {
  value: PropTypes.number,
  data: PropTypes.shape({
    $loadingStats: PropTypes.bool,
  }),
  detailUrl: PropTypes.string,
  role: PropTypes.string,
  connected: PropTypes.bool,
  license: PropTypes.bool,
  openModal: PropTypes.func,
};
UserRoleCountRenderer.defaultProps = {
  value: 0,
  detailUrl: null,
  role: null,
  connected: null,
  license: null,
  openModal: () => {},
};

export default UserRoleCountRenderer;
